import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import { MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import { ModuleFE_PathwayTransition } from '../../../../../../../_entity/pathway-transition/index.js';
import { checkIfPathwayElementChanged } from '../../../../../utils.js';
import { ModuleFE_PathwayState } from '../../../../../../../_entity/pathway-state/index.js';
import { Renderer_Transitions } from '../../../../../renderers/Renderer_Transitions.js';
export class Section_AllPathwayTransitions extends ComponentSync {
    __onPathwayTransitionUpdated(...params) {
        if (!this.props.pathwayId)
            return;
        checkIfPathwayElementChanged(this.state.relevantTransitions, params, (item) => item.pathwayIds.includes(this.props.pathwayId), () => this.reDeriveState(), () => this.reDeriveState());
    }
    deriveStateFromProps(nextProps, state) {
        state.relevantTransitions = this.getTransitions();
        return state;
    }
    getTransitions() {
        let pathwayTransitions = ModuleFE_PathwayTransition.cache.filter(transition => transition.pathwayIds.includes(this.props.pathwayId));
        pathwayTransitions = sortArray(pathwayTransitions, transition => {
            const target = ModuleFE_PathwayState.cache.unique(transition.targetId);
            const origin = ModuleFE_PathwayState.cache.unique(transition.sourceId);
            if (!origin)
                throw new MUSTNeverHappenException(`Could not find state for id ${transition.sourceId}`);
            if (!target)
                throw new MUSTNeverHappenException(`Could not find state for id ${transition.targetId}`);
            return [origin.name.toLowerCase(), target.name.toLowerCase()];
        });
        return pathwayTransitions;
    }
    render() {
        return _jsx(TS_CollapsableContainerV2, { headerRenderer: _jsxs(_Fragment, { children: [this.state.relevantTransitions.length, " Transitions"] }), containerRenderer: _jsx(Renderer_Transitions, { transitions: this.state.relevantTransitions, functions: this.props.functions }), animated: true });
    }
}
//# sourceMappingURL=Section_AllPathwayTransitions.js.map